@let defaultHeightPercentageValue = heightClass ? '' : '100%';
<div
  #tooltip="nzTooltip"
  nz-tooltip
  [nzTooltipTrigger]="null"
  [nzTooltipTitle]="tooltipInformation"
  [nzTooltipColor]="'#fff'"
  [nzTooltipMouseEnterDelay]="0.3"
  [nzTooltipPlacement]="tooltipPlacement"
  [nzTooltipOverlayStyle]="tooltipStyling"
  [nzTooltipArrowPointAtCenter]="true"
  [style.height]="defaultHeightPercentageValue"
  [ngClass]="heightClass"
>
  <ng-content></ng-content>
</div>

<ng-template #tooltipInformation>
  <wilson-shift-card-tooltip
    (mouseover)="setIsInteracting(true)"
    (mouseout)="setIsInteracting(false)"
    [showShiftValidation]="showShiftValidation"
    [plannedShiftStartDateTime]="plannedShiftStartDateTime"
    [plannedShiftEndDateTime]="plannedShiftEndDateTime"
    [accurateShiftStartDateTime]="accurateShiftStartDateTime"
    [accurateShiftEndDateTime]="accurateShiftEndDateTime"
    [shiftStartTimeDifference]="shiftStartTimeDifference"
    [shiftEndTimeDifference]="shiftEndTimeDifference"
    [shiftStartTimeType]="shiftStartTimeType"
    [shiftEndTimeType]="shiftEndTimeType"
    [plannedStartLocation]="plannedStartLocation"
    [plannedEndLocation]="plannedEndLocation"
    [reportedStartLocation]="reportedStartLocation"
    [reportedEndLocation]="reportedEndLocation"
    (tooltipExpanded)="onTooltipExpanded()"
  ></wilson-shift-card-tooltip>
</ng-template>
